import { emDash, ellipsis } from 'prosemirror-inputrules';
import { debounce } from 'lodash';

import {
  InlineAnnotationsService,
  ImageService,
  LinkService,
  ListsService,
  BaseService,
  //BlockQuoteService,
  DisplayBlockLevelService,
  TextBlockLevelService,
  NoteService,
  TrackChangeService,
  CommentsService,
  CodeBlockService,
  DisplayTextToolGroupService,
  MathService,
  FindAndReplaceService,
  EditingSuggestingService,
  FullScreenService,
  SpecialCharactersService,
  HighlightService,
  BottomInfoService,
  TransformService,
  CustomTagService,
  disallowPasteImagesPlugin,
  BlockDropDownToolGroupService,
  AskAiContentService,
  YjsService,
} from 'wax-prosemirror-services';

import { TablesService, tableEditing, columnResizing } from 'wax-table-service';

import { EditoriaSchema } from 'wax-prosemirror-core';
import CharactersList from './CharactersList';
import TextTypoService from '../services/Typography/TextTypoService';
import OutlineSideBar from '../services/Outline/OutlineSideBar';
import { postRevisedData } from '../../documents/apiController';
import { showToaster, toasterTypes } from '../../../widgets';
import VersionConfig from '../services/VersionHistory/VersionConfig';
import CustomTableService from '../services/TableStyleCustom/CustomTableService';
import { CitationService, CitationToolGroupService, CitationSyncPlugin } from '../services/CitationService';

/**
 * on save
 * create json format 
 */
const onSaveDocument = (contentData) => {
  let data = JSON.parse(localStorage.getItem("projectData"));
  console.log(data)
  let docId = localStorage.getItem("documentSelected")
  let parsedJSON = JSON.parse(localStorage.getItem(docId));
  let commentsData = JSON.parse(localStorage.getItem(docId+"_com"));
  console.log(commentsData)
  let Obj = {
    "topic_id": data.TopicID,
    "project_id": data.id,
    "doc_id": docId,
    "content": parsedJSON,
    "comment": commentsData
  }

  try {
    let saveDocResponse = postRevisedData(Obj);
    if (saveDocResponse) {
      showToaster(toasterTypes.SUCCESS, "Document saved successfully!!")
    }
  } catch (error) {
    throw error;
  }
}

// A second { options } param to handle calls bahavior
// this options will have the same names as in aiServce but in camelCase
async function DummyPromise(userInput, { askKb }) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      console.log('User input:', userInput);
      if (userInput === 'reject') {
        reject('Your request could not be processed for now');
      } else {
        // JSON response test
        const json = JSON.stringify({
          content:
            askKb ? 'KB will be queried' : 'Just a normal call',
          citations: ['citation 1', 'citation 2', 'citation 3'],
          links: ['https://coko.foundation/', 'https://waxjs.net/about/'],
        });
        resolve(json);
      }
    }, 3150);
  });
}

const updateTitle = debounce(title => {
  // console.log(title);
}, 100);

const getComments = debounce((comments) => {
  localStorage.setItem("isChanged", "true");
  let docId = localStorage.getItem("documentSelected");
  let currentUser = JSON.parse(localStorage.getItem('coguide_user'));

  let previousComments =
    JSON.parse(localStorage.getItem(docId + "_com")) || [];

  let newOrUpdatedComments = [];

  let updatedComments = comments.map((comment) => {
    let prevComment = previousComments.find((prev) => prev.id === comment.id);
    let updatedConversation = [...comment.data.conversation];

    if (!prevComment) {
      // If it's a completely new comment, update the last message's displayName to current logged in user
      if (updatedConversation.length > 0) {
        updatedConversation[updatedConversation.length - 1] = {
          ...updatedConversation[updatedConversation.length - 1],
          displayName: currentUser?.FullName || currentUser?.EmailID,
        };
      }
      newOrUpdatedComments.push({
        title: comment.data.title,
        messages: updatedConversation,
      });
    } else {
      // Check for new messages in an existing comment
      let prevMessages = prevComment.data.conversation || [];
      let newMessages = updatedConversation.filter(
        (msg) =>
          !prevMessages.some((prevMsg) => prevMsg.timestamp === msg.timestamp)
      );

      if (newMessages.length > 0) {
        // Change only the last new message's displayName to current logged in user
        let lastNewMessageIndex =
          updatedConversation.length - newMessages.length;
        updatedConversation[lastNewMessageIndex + newMessages.length - 1] = {
          ...updatedConversation[lastNewMessageIndex + newMessages.length - 1],
          displayName: currentUser?.FullName || currentUser?.EmailID,
        };

        newOrUpdatedComments.push({
          title: comment.data.title,
          messages: newMessages,
        });
      }
    }

    return {
      ...comment,
      data: {
        ...comment.data,
        conversation: updatedConversation,
      },
    };
  });

  localStorage.setItem(docId + "_com", JSON.stringify(updatedComments));

  console.log(docId, updatedComments);
}, 2000);

let docId = localStorage.getItem("documentSelected")

const setComments = (
  comments = localStorage.getItem(docId+"_com") && JSON.parse(localStorage.getItem(docId+"_com")) || [],
) => {
  return comments;
};

const saveTags = tags => {
  // console.log(tags);
};

const updateTrackStatus = status => {
  // console.log('status', status);
};

const onWarning = message => {
  alert(message);
};

export default {
  MenuService: [
    {
      templateArea: 'topBar',
      toolGroups: [
        'Base',
        'BlockDropDown',
        {
          name: 'Annotations',
          more: [
            'Superscript',
            'Subscript',
            'SmallCaps',
            'Underline',
            'StrikeThrough',
          ],
        },
        'HighlightToolGroup',
        'TransformToolGroup',
        'CustomTagInline',
        'Lists',
        'Images',
        'SpecialCharacters',
        'CodeBlock',
        'Tables',
        'Citations',
        'TrackingAndEditing',
        'FullScreen',
      ],
    },
    {
      templateArea: 'commentTrackToolBar',
      toolGroups: ['TrackCommentOptions'],
    },
    {
      templateArea: 'BottomRightInfo',
      toolGroups: ['InfoToolGroup'],
    },
  ],

  OrderedListService: { subList: true },
  BulletListService: { subList: true },
  JoinUpService: { subList: true },
  SpecialCharactersService: CharactersList,
  SchemaService: EditoriaSchema,
  TitleService: { updateTitle },
  RulesService: [emDash, ellipsis],
  ShortCutsService: {},
  EnableTrackChangeService: { enabled: false, toggle: true, updateTrackStatus },
  AcceptTrackChangeService: {
    own: {
      accept: true,
    },
    others: {
      accept: true,
    },
  },
  RejectTrackChangeService: {
    own: {
      reject: true,
    },
    others: {
      reject: true,
    },
  },
  PmPlugins: [
    tableEditing(),
    columnResizing(),
    CitationSyncPlugin,
    // disallowPasteImagesPlugin(() =>
    //   onWarning(
    //     'Images are not allowed. Please upload them through filemanager',
    //   ),
    // ),
  ],
  ImageService: { showAlt: true },
  SaveService: {
    saveSource: source => {
      console.log(JSON.stringify(source));
      onSaveDocument(JSON.stringify(source));
    },
  },
  CommentsService: {
    showTitle: true,
    getComments,
    setComments,
  },

  CustomTagService: {
    tags: [
      { label: 'custom-tag-label-1', tagType: 'inline' },
      { label: 'custom-tag-label-2', tagType: 'inline' },
      { label: 'custom-tag-label-3', tagType: 'block' },
      { label: 'label 2', tagType: 'block' },
    ],
    updateTags: saveTags,
  },


  AskAiContentService: {
    AskAiContentTransformation: DummyPromise,
    AiOn: true,
    AskKb: true,
    CustomPromptsOn: true,
    FreeTextPromptsOn: true,
    CustomPrompts: [],
  },

  services: [
    new BlockDropDownToolGroupService(),
    new AskAiContentService(),
    new CustomTagService(),
    new DisplayBlockLevelService(),
    new TextBlockLevelService(),
    new ListsService(),
    new LinkService(),
    new InlineAnnotationsService(),
    new TrackChangeService(),
    new CommentsService(),
    new ImageService(),
    new TablesService(),
    new BaseService(),
    new CodeBlockService(),
    new EditingSuggestingService(),
    new DisplayTextToolGroupService(),
    new MathService(),
    new FindAndReplaceService(),
    new FullScreenService(),
    new SpecialCharactersService(),
    new HighlightService(),
    new BottomInfoService(),
    new TransformService(),
    new OutlineSideBar(),
    new TextTypoService(),
    new VersionConfig(),
    new CustomTableService(),
    new CitationService(),
    new CitationToolGroupService(),
  ],
};
